import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const InvoiceCountryTaxDetails = ({ taxNumber, taxName, phoneNumber }) => {
  return (
   ((taxName && taxNumber) || phoneNumber) &&
     <div className="flex space-between items-center">
       <div className="flex column">
         {(taxName && taxNumber) &&
           <>
             <div className="text-small text-gray-600">
               {taxName}:
             </div>
             <div className="heavy">{taxNumber}</div>
           </>
         }
       </div>
       <div className="flex column text-right">
         {phoneNumber &&
           <>
             <div className="text-small text-gray-600">
               <FormattedMessage
                 id="hosting.sales_tax_invoice.phone_number"
                 defaultMessage="Phone Number"
               />:
             </div>
             <div className="heavy">{phoneNumber}</div>
           </>
         }
       </div>
     </div>
  );
};


InvoiceCountryTaxDetails.propTypes = {
  taxNumber: PropTypes.string,
  taxName: PropTypes.string,
  phoneNumber: PropTypes.string
};

export { InvoiceCountryTaxDetails };